/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsInternetIdentityUserCountFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsInternetIdentityUserCountFormat = ClosedEnum<
  typeof GetApiV3MetricsInternetIdentityUserCountFormat
>;

export type GetApiV3MetricsInternetIdentityUserCountRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsInternetIdentityUserCountFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsInternetIdentityUserCountFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsInternetIdentityUserCountFormat> = z
    .nativeEnum(GetApiV3MetricsInternetIdentityUserCountFormat);

/** @internal */
export const GetApiV3MetricsInternetIdentityUserCountFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsInternetIdentityUserCountFormat> =
    GetApiV3MetricsInternetIdentityUserCountFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsInternetIdentityUserCountFormat$ {
  /** @deprecated use `GetApiV3MetricsInternetIdentityUserCountFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsInternetIdentityUserCountFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsInternetIdentityUserCountFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsInternetIdentityUserCountFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsInternetIdentityUserCountRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsInternetIdentityUserCountRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsInternetIdentityUserCountFormat$inboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsInternetIdentityUserCountRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsInternetIdentityUserCountRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsInternetIdentityUserCountRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsInternetIdentityUserCountRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsInternetIdentityUserCountFormat$outboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsInternetIdentityUserCountRequest$ {
  /** @deprecated use `GetApiV3MetricsInternetIdentityUserCountRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsInternetIdentityUserCountRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsInternetIdentityUserCountRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsInternetIdentityUserCountRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsInternetIdentityUserCountRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsInternetIdentityUserCountRequest$Outbound;
}

export function getApiV3MetricsInternetIdentityUserCountRequestToJSON(
  getApiV3MetricsInternetIdentityUserCountRequest:
    GetApiV3MetricsInternetIdentityUserCountRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsInternetIdentityUserCountRequest$outboundSchema.parse(
      getApiV3MetricsInternetIdentityUserCountRequest,
    ),
  );
}

export function getApiV3MetricsInternetIdentityUserCountRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsInternetIdentityUserCountRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsInternetIdentityUserCountRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsInternetIdentityUserCountRequest' from JSON`,
  );
}
